/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Paper, Theme } from '@mui/material';
import LegacyGrid from './legacy/LegacyGrid';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { categories, Category, CategoryType } from '../common/Categories';
import { checkUserAuthorized } from '../common/common';
import { loadFromLocalStorage } from '../common/localStorage';
import { history } from '../store/history';
import { BASE_URL } from '../common/constants';
import MyTab from './MyTab';
import MyTrainingAuthorizations from './MyTrainingAuthorizations';
import TeamTrainingAuthorizations from './TeamTrainingAuthorizations';
import AllTrainingAuthorizations from './AllTrainingAuthorizations';
import TeamProductAuthorizations from './TeamProductAuthorizations';
import AllProductAuthorizations from './AllProductAuthorizations';
import { withRouterCompat, RouteComponentPropsCompat } from '../common/withRouter';

interface Props extends RouteComponentPropsCompat {
    classes?: any;
}
const styles = (theme: Theme) => ({
    root: {
        width: '100%',
    },
    message: {
        borderRadius: '0px',
        textAlign: 'center' as const,
        padding: '20px',
        marginTop: '20px'
    },
});
class Authorization extends React.Component<Props>{
    state = {
        selectedCategoryId: 8,
        isUnauthorized: false
    };
    componentDidMount() {
        console.log('Authorization - componentDidMount, location:', this.props.location);
        const enabledModules: any = checkUserAuthorized();
        if (enabledModules == null) {
            return;
        }
        if (enabledModules.length !== 0) {
            this.setSelectedTab();
        }
        else {
            this.setState({ isUnauthorized: true });
        }
    }
    setSelectedTab = () => {
        if (this.props.location !== undefined) {
            const path = this.props.location.pathname || '';
            // Prefer the most specific matching route (longest path) so nested routes select correct tab
            const selectedCategory: Category | undefined = categories
                .filter((category: Category) => category.route !== undefined && path.startsWith(category.route as string))
                .sort((a: Category, b: Category) => ((a.route?.length || 0) < (b.route?.length || 0) ? 1 : -1))
                [0];
            if (selectedCategory !== undefined) {
                console.log('Authorization - setSelectedTab to:', selectedCategory.id, selectedCategory.name);
                this.setState({ selectedCategoryId: selectedCategory.id });
            }
        }
    };
    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        if (this.props.location !== prevProps.location) {
            console.log('Authorization - location changed from', prevProps.location.pathname, 'to', this.props.location.pathname);
            this.setSelectedTab();
        }
    }
    handleTabChange(categoryId: number) {
        if (categoryId !== undefined) {
            this.setState(
                {
                    selectedCategoryId: categoryId
                }
            );
            const selectedCategory: Category | undefined =
                categories.find((category: Category) => { return category.id === categoryId; });
            if (selectedCategory !== undefined && selectedCategory.route !== undefined) {
                console.log('Authorization - handleTabChange navigating to:', selectedCategory.route);
                this.props.history.push(selectedCategory.route);
            }
        }
    }
    render() {
        console.log('Authorization - render, location:', this.props.location?.pathname, 'selectedCategoryId:', this.state.selectedCategoryId);
        const { classes } = this.props;
        const enabledModules: Array<any> = loadFromLocalStorage('Enabled Modules');
        let filteredCategories: Array<Category> = [], errorFetchingModules = false;
        if (enabledModules != null && enabledModules.length !== 0) {
            if (enabledModules[0] !== -99) {
                filteredCategories = categories.filter((category: Category) => {
                    return enabledModules.find((module: any) => {
                        return module.modulename===category.moduleName && (category.type===CategoryType.TrainingAuthorization || category.type===CategoryType.ProductAuthorization);
                    }) !== undefined;
                });
            }
            else {
                errorFetchingModules = true;
            }
        }
        console.log('Authorization - filteredCategories:', filteredCategories.map(c => c.name));
        return (
            (!this.state.isUnauthorized && filteredCategories.length !== 0) && !errorFetchingModules ?
                <div>
                    <div className={classes.root}>
                        <LegacyGrid container spacing={32}>
                            <LegacyGrid item>
                                <MyTab
                                    categories={filteredCategories}
                                    selectedTab={this.state.selectedCategoryId}
                                    onTabChange={this.handleTabChange.bind(this)}
                                />
                                <br />
                            </LegacyGrid>
                        </LegacyGrid>
                    </div>
                    <Outlet />
                </div>
                :
                <Paper className={classes.message}>
                    {errorFetchingModules ? 'Unable to fetch data.Please try again later' : 'You are not authorized to view the data.'}
                </Paper>
        );
    }
}

export default withRouterCompat(withStyles(styles)(Authorization));
